import { History } from 'history'

import * as actionTypes from './actionTypes'

export type ChangedPayloadType = {
  action: History['action']
  location: Partial<History['location']>
}
export type ChangedActionType = {
  type: string
  payload: ChangedPayloadType
}
export const changed = ({
  action,
  location,
}: ChangedPayloadType): ActionType => ({
  type: actionTypes.CHANGED,
  payload: { action, location },
})
